"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var createBreakpoints_1 = __importDefault(require("@material-ui/core/styles/createBreakpoints"));
// createBreakpoints will add media query functions like 'up', 'down', and 'between'
var _breakpoints = (0, createBreakpoints_1.default)({
    keys: ['xs', 'sm', 'md', 'lg', 'xl'],
    values: {
        xs: 0,
        sm: 960,
        md: 1024,
        lg: 1440,
        xl: 1920,
    },
});
var breakpoints = __assign(__assign({}, _breakpoints), { modalPageCollapsed: _breakpoints.down('sm') });
exports.default = breakpoints;
